module.exports = __webpack_public_path__ + "static/05-758d15d6da969d873771a80522a00a61.jpg";